import $ from 'jquery';
import baseInitialize from './base';
import CSRFactoryMap from 'components/csrFactoryMap/CSRFactoryMap';

baseInitialize();

const $map = $('#csr-map');
let options;

if ($map.length) {
  document.body.classList.add('csr-map');

  if (window.location.href.indexOf('factoryId=') > 0) {
    const regex = new RegExp(`[?&]factoryId(=([^&#]*)|&|#|$)`);
    const url = window.location.href;
    const results = regex.exec(url);

    if (results && results[2]) {
      options = {
        el: $map[0],
        factoryId: results[2],
        isStatic: true
      };
    }
  } else {
    options = {
      el: $map[0]
    };
  }
}

new CSRFactoryMap(options);
